import { ParteReato } from './parte-reato';

export class ParteReatoArray {
  parteReato: ParteReato;
  id: string;
}
